/** Line item → add_on | your_pick | duplin_pick from properties. */
export function getItemType(item, index, allItems = []) {
  const props = item.properties || item.customAttributes || item.lineItemProperties || [];
  const arr = Array.isArray(props) ? props : [];
  const propWine = arr.find(
    (p) =>
      p?.key === "wine_club_subscription" ||
      p?.name === "wine_club_subscription" ||
      String(p?.key || "")
        .toLowerCase()
        .replace(/\s/g, "_") === "wine_club_subscription"
  );
  let val = propWine ? String(propWine.value ?? "").trim().toLowerCase() : "";
  if (!val) {
    const propLine = arr.find((p) => p?.key === "line_type" || p?.name === "line_type");
    val = String(propLine?.value ?? "").trim().toLowerCase();
  }
  if (val === "add_on") return "add_on";
  if (val === "your_pick") return "your_pick";
  if (val === "duplin_pick") return "duplin_pick";
  return "your_pick";
}

export function toProductShape(item, type) {
  const rawPrice =
    item.itemPrice != null && item.itemPrice !== ""
      ? item.itemPrice
      : item.price != null && item.price !== ""
        ? item.price
        : null;
  const numPrice = rawPrice != null ? Number(rawPrice) : null;
  return {
    id: item.lineItemId || item.variantId || item.productId,
    variantId: item.variantId,
    productId: item.productId ?? item.product_id ?? null,
    title: item.title,
    image: item.image,
    price: Number.isNaN(numPrice) ? null : numPrice,
    quantity: item.quantity || item.currentQuantity || 1,
    type,
  };
}
